import { WebPlugin } from '@capacitor/core';
import { CaptureVisionRouter } from "dynamsoft-capture-vision-router";
import { CoreModule } from 'dynamsoft-core';
import { LicenseManager } from 'dynamsoft-license';
import "dynamsoft-license";
import "dynamsoft-barcode-reader";
import "dynamsoft-capture-vision-router";
export class DBRWeb extends WebPlugin {
    constructor() {
        super(...arguments);
        this.engineResourcePaths = {
            rootDirectory: "https://cdn.jsdelivr.net/npm/"
        };
    }
    async initLicense(options) {
        try {
            await LicenseManager.initLicense(options.license);
        }
        catch (error) {
            console.log(error);
            throw error;
        }
        return { success: true };
    }
    decodeBitmap(_options) {
        throw new Error('Method not implemented.');
    }
    async initialize() {
        try {
            // Configures the paths where the .wasm files and other necessary resources for modules are located.
            CoreModule.engineResourcePaths.rootDirectory = this.engineResourcePaths.rootDirectory;
            await CoreModule.loadWasm(["cvr", "dbr"]);
            this.cvr = await CaptureVisionRouter.createInstance();
        }
        catch (error) {
            throw error;
        }
        return { success: true };
    }
    async setEngineResourcePaths(options) {
        this.engineResourcePaths = options.paths;
    }
    async initRuntimeSettingsFromString(options) {
        if (this.cvr) {
            await this.cvr.initSettings(options.template);
        }
        else {
            throw new Error("DBR not initialized.");
        }
    }
    async decode(options) {
        var _a;
        let wrappedResults = [];
        if (this.cvr) {
            if (this.cvr) {
                let templateName = (_a = options.template) !== null && _a !== void 0 ? _a : "ReadBarcodes_Balance";
                let result = await this.cvr.capture(options.source, templateName);
                let results = [];
                for (let index = 0; index < result.items.length; index++) {
                    const item = result.items[index];
                    results.push(item);
                }
                for (let index = 0; index < results.length; index++) {
                    const result = results[index];
                    const wrappedResult = {
                        barcodeText: result.text,
                        barcodeFormat: result.formatString,
                        barcodeBytesBase64: this.arrayBufferToBase64(result.bytes),
                        x1: result.location.points[0].x,
                        y1: result.location.points[0].y,
                        x2: result.location.points[1].x,
                        y2: result.location.points[1].y,
                        x3: result.location.points[2].x,
                        y3: result.location.points[2].y,
                        x4: result.location.points[3].x,
                        y4: result.location.points[3].y,
                    };
                    wrappedResults.push(wrappedResult);
                }
            }
            else {
                throw new Error("DBR not initialized.");
            }
        }
        return { results: wrappedResults };
    }
    arrayBufferToBase64(bytes) {
        var binary = '';
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
}
//# sourceMappingURL=web.js.map